import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <a href="/" className="flex items-center space-x-2 cursor-pointer">
            <div className="w-8 h-8 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-lg flex items-center justify-center">
              <i className="ri-bank-card-line text-white text-lg"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">クレカ比較ナビ</span>
          </a>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-sm font-medium text-gray-700 hover:text-[#FFB800] transition-colors cursor-pointer whitespace-nowrap">
              ホーム
            </a>
            <a href="/ranking" className="text-sm font-medium text-gray-700 hover:text-[#FFB800] transition-colors cursor-pointer whitespace-nowrap">
              ランキング
            </a>
            <a href="/comparison" className="text-sm font-medium text-gray-700 hover:text-[#FFB800] transition-colors cursor-pointer whitespace-nowrap">
              比較する
            </a>
            <a
              href="#top-cards"
              className="bg-[#FFB800] text-white px-6 py-2 rounded-lg text-sm font-bold hover:bg-[#FFA000] transition-all cursor-pointer whitespace-nowrap"
            >
              おすすめカードを見る
            </a>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <a href="/" className="text-sm font-medium text-gray-700 hover:text-[#FFB800] transition-colors cursor-pointer">
                ホーム
              </a>
              <a href="/ranking" className="text-sm font-medium text-gray-700 hover:text-[#FFB800] transition-colors cursor-pointer">
                ランキング
              </a>
              <a href="/comparison" className="text-sm font-medium text-gray-700 hover:text-[#FFB800] transition-colors cursor-pointer">
                比較する
              </a>
              <a
                href="#top-cards"
                className="bg-[#FFB800] text-white px-6 py-3 rounded-lg text-sm font-bold hover:bg-[#FFA000] transition-all cursor-pointer text-center whitespace-nowrap"
              >
                おすすめカードを見る
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
